import styled, { css } from "styled-components";
import { theme } from "../../../../constants/StyledComponents";

export const StyledCMSheet = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;

  & .cm-sheet-empty-state {
    justify-items: center;
    align-content: center;
  }
`;

export const StyledCMSheetFooter = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
`;

export const CMSheetTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  gap: 20px;
  flex-wrap: wrap;

  & .title-switch {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;

    & .title-icon {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
`;

export const SlideInfoTooltipContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StyledCMSheetContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px;
  flex: 1;
`;

export const EditModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 420px;
  box-sizing: border-box;

  & section {
    width: 50%;
  }

  & .file-uploader-container {
    width: 552px;
  }

  & .input-row {
    display: flex;
    flex-direction: row;
    gap: 20px;

    & div {
      max-width: 265px;
    }
  }
`;

export const StyledHideOrShowContainer = styled.div<{ $show: boolean }>`
  ${({ $show }) =>
    !$show
      ? css`
          display: none;
        `
      : undefined}
`;

export const StyledHeaderTab = styled.div`
  display: flex;
  flex-direction: row;
  padding: 20px;
  align-items: center;
  gap: 32px;
  border-bottom: 1px solid ${theme.colors.purple_2};

  & > button {
    width: 165px;
  }

  & > div > div > div {
    margin: 2px 0;
  }
`;

export const StyledLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const StyledEmptyContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100dvh - 140px);
`;

export const StyledTabContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledMenuContent = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`;
